import { QueryObserverBaseResult, useQuery } from "react-query";
import { queryKeys } from "../../query";
import api from "../../client";
import { ChecklistDetailResponseData } from "../../types/checklist";

export const getData = async (
  id: string | undefined,
): Promise<ChecklistDetailResponseData> => {
  const { data } = await api.get(`/checklists/${id}`);

  return data;
};

export const useChecklist = (
  id: string | undefined,
): QueryObserverBaseResult<ChecklistDetailResponseData> => {
  const { data, ...props } = useQuery(
    queryKeys.checklist(id),
    () => getData(id),
    { enabled: Boolean(id) },
  );
  return { data, ...props };
};
